import React from 'react';
import { motion } from 'framer-motion';
import Header from './components/Header';
import InfoBar from './components/InfoBar';
import Footer from './components/Footer';
import Home from './pages/HomePage/Home';
import LoanCosts from './pages/Costs/Costs';
import ApplyNow from './pages/ApplyNow/ApplyNow';
import ContactUs from './pages/ContactUs/ContactUs';
import './App.css';
import { Routes, Route } from 'react-router-dom';
//import PrivacyAndCredit from './pages/Legal/PrivacyAndCredit';
import CreditInformation from './pages/Legal/CreditInformation';
import CreditGuides from './pages/Legal/CreditGuides';
import Complaints from './pages/Legal/Complaints';
import WebsitePrivacy from './pages/Legal/WebsitePrivacy';
import Disclaimer from './pages/Legal/Disclaimer';
import TargetMarket from './pages/Legal/TargetMarket';

function App() {
  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <InfoBar />
      <motion.main 
        className="flex-grow"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1, duration: 0.5 }}
      >
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/apply-now" element={<ApplyNow />} />
          <Route path="/costs" element={<LoanCosts />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/legal/privacy-statement" element={<WebsitePrivacy />} />
          <Route path="/legal/credit-information" element={<CreditInformation />} />
          <Route path="/legal/credit-guides" element={<CreditGuides />} />
          <Route path="/legal/complaints" element={<Complaints />} />
          <Route path="/legal/disclaimer" element={<Disclaimer />} />
          <Route path="/legal/target-market" element={<TargetMarket />} />
        </Routes>
      </motion.main>
      <Footer />
    </div>
  );
}

export default App;
